import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import GorgiasCredentialsStore from '../../../stores/credentials/gorgias-credentials-store';

interface IIntegrationProps {
    credentialsStore: GorgiasCredentialsStore,
    vGroup: IValidationGroup,
}

const GorgiasCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine
                label='Base API URL'
                note='e.g. your-name.gorgias.com'
                required
                key='api_url'
            >
                <Input
                    value={credentialsStore.api_url}
                    placeholder=''
                    onChange={v => credentialsStore.api_url = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Username (your email address)'
                note='e.g. your-gorgias-email@your-email-domain.com'
                required
                key='username'
            >
                <Input
                    value={credentialsStore.username}
                    placeholder=''
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Password (API Key)'
                note='As seen at https://your-name.gorgias.com/app/settings/api'
                required
                key='password'
            >
                <Input
                    value={credentialsStore.password}
                    placeholder=''
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default GorgiasCredentials;
